import {
  type MonthlyTourReportInvoiceDetailExEntity,
  apiClient
} from '@/libs/api'

export type FetchMonthlyTourReportInvoiceDetailQuery = {
  tenantKey: string
  monthlyTourReportId: number
}

export const fetchMonthlyTourReportInvoiceDetails = async (
  { tenantKey, monthlyTourReportId }: FetchMonthlyTourReportInvoiceDetailQuery,
  signal?: AbortSignal
): Promise<MonthlyTourReportInvoiceDetailExEntity[]> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .monthly_tour_reports._id(monthlyTourReportId)
    .invoice.details.$get({
      config: { signal }
    })
  return data
}
